import React, { useRef } from 'react';
import { Avatar } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import {
  CONTENT_SUBMISSION_APPROVED_NOTIF_TYPE,
  CONTENT_SUBMISSION_FEEDBACK_ADDED_NOTIF_TYPE,
} from '@Saral-Influencer-Marketing/saral-utils/src/constants/notification';
import { NotificationType } from '../types';
import styles from './Notification.module.css';
import ArrowIcon from '../../../../assets/icons/ArrowIcon';

interface NotificationItemProps {
  notification: NotificationType;
}

function NotificationItem({ notification }: NotificationItemProps) {
  const notificationRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();

  const isFeedbackAddedNotification = notification?.type === CONTENT_SUBMISSION_FEEDBACK_ADDED_NOTIF_TYPE;

  const isContentSubmissionApprovedNotification = notification?.type === CONTENT_SUBMISSION_APPROVED_NOTIF_TYPE;

  const isContentSubmissionNotification = isFeedbackAddedNotification || isContentSubmissionApprovedNotification;

  return (
    <div className={styles.notificationItemContainer} ref={notificationRef}>
      <Avatar src={notification?.content?.userProfileUrl} size="36px" radius="xl" />
      <div className={styles.notificationContent}>
        <div className={styles.notificationContentTitle}>{notification.title}</div>
        <div
          role="presentation"
          className={styles.notificationContentCallToAction}
          onClick={() => {
            const usageRightRequest = notification.content?.usageRightData;
            if (isContentSubmissionNotification) {
              navigate(`/dashboard/submissions?tab=${isFeedbackAddedNotification ? 'changesRequested' : 'approved'}`);
            } else {
              navigate('/dashboard/usage-rights', { state: { usageRightRequest } });
            }
          }}
        >
          Review <ArrowIcon />
        </div>
      </div>
    </div>
  );
}

export default NotificationItem;
